module.exports = __webpack_public_path__ + "media/images/game/resources/money_medium-739bd333ee7962275701aa59f9cc5e9c.png";